export const parseHslStringToHslArgs = (hslString) => {
  if (!hslString?.includes('hsl')) {
    return '';
  }

  const arrayArgs = hslString
    .substring(hslString?.indexOf('(') + 1, hslString?.lastIndexOf(')'))
    ?.split(',');

  return arrayArgs?.map((arg) => parseInt(arg));
};
